import { SellingPointModel } from "../../model/sellingPoint.model";

export const initialState = {
  loading: false,
  isAuthenticated: false,
  account: {} as any,
  errorMessage: (null as unknown) as string, // Errors returned from server side
  redirectMessage: (null as unknown) as string,
  logoutUrl: (null as unknown) as string,
  sessionHasBeenFetched: false,
  idToken: null as string,
  sellingPointModel: new SellingPointModel(),

};

export type AuthenticationState = Readonly<typeof initialState>;
